var __create = Object.create;
var __defProp = Object.defineProperty,
  __defProps = Object.defineProperties,
  __getOwnPropDesc = Object.getOwnPropertyDescriptor,
  __getOwnPropDescs = Object.getOwnPropertyDescriptors,
  __getOwnPropNames = Object.getOwnPropertyNames,
  __getOwnPropSymbols = Object.getOwnPropertySymbols,
  __getProtoOf = Object.getPrototypeOf,
  __hasOwnProp = Object.prototype.hasOwnProperty,
  __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value
  }) : obj[key] = value,
  __spreadValues = (a, b) => {
    for (var prop in b || (b = {})) __hasOwnProp.call(b, prop) && __defNormalProp(a, prop, b[prop]);
    if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) __propIsEnum.call(b, prop) && __defNormalProp(a, prop, b[prop]);
    return a;
  },
  __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source) __hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0 && (target[prop] = source[prop]);
  if (source != null && __getOwnPropSymbols) for (var prop of __getOwnPropSymbols(source)) exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop) && (target[prop] = source[prop]);
  return target;
};
var __commonJS = (cb, mod) => function () {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = {
    exports: {}
  }).exports, mod), mod.exports;
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function") for (let key of __getOwnPropNames(from)) !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, {
    get: () => from[key],
    enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
  });
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", {
  value: mod,
  enumerable: !0
}) : target, mod));
var require_cjs = __commonJS({
  "../../node_modules/deepmerge/dist/cjs.js"(exports, module) {
    "use strict";

    var isMergeableObject = function (value) {
      return isNonNullObject(value) && !isSpecial(value);
    };
    function isNonNullObject(value) {
      return !!value && typeof value == "object";
    }
    function isSpecial(value) {
      var stringValue = Object.prototype.toString.call(value);
      return stringValue === "[object RegExp]" || stringValue === "[object Date]" || isReactElement(value);
    }
    var canUseSymbol = typeof Symbol == "function" && Symbol.for,
      REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for("react.element") : 60103;
    function isReactElement(value) {
      return value.$$typeof === REACT_ELEMENT_TYPE;
    }
    function emptyTarget(val) {
      return Array.isArray(val) ? [] : {};
    }
    function cloneUnlessOtherwiseSpecified(value, options) {
      return options.clone !== !1 && options.isMergeableObject(value) ? deepmerge(emptyTarget(value), value, options) : value;
    }
    function defaultArrayMerge(target, source, options) {
      return target.concat(source).map(function (element) {
        return cloneUnlessOtherwiseSpecified(element, options);
      });
    }
    function getMergeFunction(key, options) {
      if (!options.customMerge) return deepmerge;
      var customMerge = options.customMerge(key);
      return typeof customMerge == "function" ? customMerge : deepmerge;
    }
    function getEnumerableOwnPropertySymbols(target) {
      return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(target).filter(function (symbol) {
        return target.propertyIsEnumerable(symbol);
      }) : [];
    }
    function getKeys(target) {
      return Object.keys(target).concat(getEnumerableOwnPropertySymbols(target));
    }
    function propertyIsOnObject(object, property) {
      try {
        return property in object;
      } catch (_) {
        return !1;
      }
    }
    function propertyIsUnsafe(target, key) {
      return propertyIsOnObject(target, key) && !(Object.hasOwnProperty.call(target, key) && Object.propertyIsEnumerable.call(target, key));
    }
    function mergeObject(target, source, options) {
      var destination = {};
      return options.isMergeableObject(target) && getKeys(target).forEach(function (key) {
        destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
      }), getKeys(source).forEach(function (key) {
        propertyIsUnsafe(target, key) || (propertyIsOnObject(target, key) && options.isMergeableObject(source[key]) ? destination[key] = getMergeFunction(key, options)(target[key], source[key], options) : destination[key] = cloneUnlessOtherwiseSpecified(source[key], options));
      }), destination;
    }
    function deepmerge(target, source, options) {
      options = options || {}, options.arrayMerge = options.arrayMerge || defaultArrayMerge, options.isMergeableObject = options.isMergeableObject || isMergeableObject, options.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified;
      var sourceIsArray = Array.isArray(source),
        targetIsArray = Array.isArray(target),
        sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
      return sourceAndTargetTypesMatch ? sourceIsArray ? options.arrayMerge(target, source, options) : mergeObject(target, source, options) : cloneUnlessOtherwiseSpecified(source, options);
    }
    deepmerge.all = function (array, options) {
      if (!Array.isArray(array)) throw new Error("first argument should be an array");
      return array.reduce(function (prev, next) {
        return deepmerge(prev, next, options);
      }, {});
    };
    var deepmerge_1 = deepmerge;
    module.exports = deepmerge_1;
  }
});
import * as React from "react";
import { useReducedMotion, Globals as AnimatedGlobals } from "@twilio-paste/animation-library";
import { StylingGlobals, ThemeProvider as StyledThemeProvider } from "@twilio-paste/styling-library";
import { pasteGlobalStyles, StyledBase, DefaultTheme, DarkTheme } from "@twilio-paste/theme";
var import_deepmerge = __toESM(require_cjs());
var createCustomTheme = _ref => {
  let {
    baseTheme,
    overrides,
    customBreakpoints,
    elements
  } = _ref;
  let breakpoints = customBreakpoints || baseTheme.breakpoints,
    mergedTheme = (0, import_deepmerge.default)(baseTheme, overrides);
  if (elements != null && [...new Set(Object.keys(elements).map(element => element.toLowerCase()))].length !== Object.keys(elements).length) throw new Error("[CustomizationProvider]: duplicate element names, even when using a different casing, is not supported with Paste.");
  return __spreadProps(__spreadValues({}, mergedTheme), {
    breakpoints,
    elements
  });
};
var CustomizationProvider = _a => {
  var _b = _a,
    {
      baseTheme = "default",
      customBreakpoints,
      elements,
      theme,
      disableAnimations = !1
    } = _b,
    props = __objRest(_b, ["baseTheme", "customBreakpoints", "elements", "theme", "disableAnimations"]);
  let prefersReducedMotion = useReducedMotion();
  React.useMemo(() => {
    AnimatedGlobals.assign({
      skipAnimation: disableAnimations || prefersReducedMotion
    });
  }, [disableAnimations, prefersReducedMotion]);
  let customTheme = React.useMemo(() => createCustomTheme({
    baseTheme: baseTheme === "dark" ? DarkTheme : DefaultTheme,
    overrides: theme || {},
    elements: elements || {},
    customBreakpoints
  }), [baseTheme, customBreakpoints, elements, theme]);
  return React.createElement(StyledThemeProvider, {
    theme: customTheme
  }, React.createElement(StylingGlobals, {
    styles: pasteGlobalStyles({
      theme: customTheme
    })
  }), React.createElement(StyledBase, __spreadValues({}, props)));
};
CustomizationProvider.displayName = "PasteCustomizationProvider";
import * as React2 from "react";
import { Theme } from "@twilio-paste/theme";
var CustomizationConsumer = props => React2.createElement(Theme.Consumer, __spreadValues({}, props));
CustomizationConsumer.displayName = "PasteCustomizationConsumer";
export { CustomizationConsumer, CustomizationProvider };